import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ClinicalHero = () => {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 120);
    return () => clearTimeout(timer);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative overflow-hidden">
      {/* Minimal hero bar — same style as AboutHero */}
      <div className="w-full bg-warmWhite border-b border-charcoal/10 py-6 sm:py-10 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto flex items-center gap-4 sm:gap-6">
          <div className="flex items-center gap-2 sm:gap-3">
            <div className="w-5 sm:w-8 h-[1px] bg-charcoal/30"></div>
            <span className="text-charcoal/40 text-[9px] sm:text-[10px] font-sans font-semibold tracking-[0.35em] sm:tracking-[0.45em] uppercase whitespace-nowrap">
              Clinical Services
            </span>
          </div>
          <h1 className="font-display text-xl sm:text-3xl font-light text-charcoal italic leading-snug">
            Vionne Stability Pathway
          </h1>
          <div className="flex-1 h-[1px] bg-charcoal/10 hidden sm:block"></div>
          <p className="text-[12px] font-sans font-light text-textGray leading-relaxed tracking-wide max-w-xs hidden lg:block">
            Facial-led acupuncture, botanical neuro&#8209;modulation, and structural nervous system regulation.
          </p>
        </div>
      </div>

      {/* Page Navigation Bar */}
      <div className="relative z-10 border-t border-[#D9CFC4] bg-white">
        <div className="max-w-[1280px] mx-auto px-2 sm:px-8 lg:px-12">
          <nav className="flex items-center gap-0">
            {[
              { label: "Our Services", id: "services-grid", icon: "ri-sparkling-line" },
              { label: "Common Questions", id: "clinical-faq", icon: "ri-question-line" },
              { label: "Insurance Benefits", id: "insurance-info", icon: "ri-shield-check-line" },
              { label: "Booking Process", id: "booking-process", icon: "ri-calendar-check-line" },
            ].map((item, i) => (
              <button
                key={i}
                onClick={() => scrollTo(item.id)}
                className="group flex items-center gap-1 sm:gap-2 px-2 py-3 sm:px-5 sm:py-3.5 text-[8px] sm:text-[10px] font-sans font-semibold tracking-[0.1em] sm:tracking-[0.2em] uppercase text-[#4A4440] hover:text-[#b8956a] transition-all duration-300 whitespace-nowrap cursor-pointer border-b-[1.5px] border-transparent hover:border-[#b8956a] relative flex-1 justify-center"
              >
                <div className="hidden sm:flex w-3.5 h-3.5 items-center justify-center">
                  <i className={`${item.icon} text-[11px]`} />
                </div>
                <span>{item.label}</span>
              </button>
            ))}
          </nav>
        </div>
      </div>
    </section>
  );
};

export default ClinicalHero;
